/**
 * Tableau des 8 meilleurs 3es (specs/01 §5) — la mécanique la moins intuitive
 * du format 2026, visible en permanence dès la 2e journée.
 */
import type { OfficialState } from "../../app/officialStore.ts";
import { esc, flagSpan } from "../html.ts";
import { fmtSigned } from "../../app/format.ts";
import { t } from "../../app/i18n.ts";

const provBadge = (): string =>
  `<span class="badge-prov" title="${t("groups.liveScoreTitle")}" aria-label="${t("groups.liveScoreTitle")}"><i class="ti ti-clock" aria-hidden="true"></i></span>`;

export function renderThirdsTable(el: HTMLElement, state: OfficialState): void {
  const maxPlayed = Math.max(0, ...state.thirds.map((t) => t.played));
  if (maxPlayed < 2) {
    el.innerHTML = "";
    el.classList.add("hide");
    return;
  }
  el.classList.remove("hide");
  // Équipes dont la ligne intègre un score de match EN COURS (classement live, provisoire).
  const provisional = new Set<string>();
  for (const s of state.standings) for (const t of s.provisionalTeams) provisional.add(t);
  el.innerHTML = `
    <h2 class="sec-title">${t("thirds.title")} <span class="count">${t("thirds.subtitle")}</span></h2>
    <div class="thirds card">
      <table class="thirds-table">
        <thead><tr><th>#</th><th>${t("stats.col.team")}</th><th>${t("thirds.col.group")}</th><th>${t("stats.col.played.abbr")}</th><th>${t("stats.col.points.abbr")}</th><th>${t("thirds.col.goalDiff")}</th><th>${t("stats.col.goalsFor.abbr")}</th></tr></thead>
        <tbody>
          ${state.thirds
            .map(
              (t, i) => `
            <tr class="${i < 8 ? "in" : "out"}${provisional.has(t.team) ? " prov" : ""}">
              <td>${i + 1}</td>
              <td class="team">${flagSpan(t.team, { name: true })}${provisional.has(t.team) ? provBadge() : ""}${t.decidedByDraw ? " 🎲" : ""}</td>
              <td>${esc(t.group)}</td>
              <td>${t.played}</td>
              <td class="pts">${t.points}</td>
              <td>${fmtSigned(t.goalDiff)}</td>
              <td>${t.goalsFor}</td>
            </tr>`,
            )
            .join("")}
        </tbody>
      </table>
      <p class="note">${t("thirds.criteria")}${
        provisional.size ? ` <i class="ti ti-clock" aria-hidden="true"></i> ${t("thirds.liveNote")}` : ""
      }</p>
    </div>`;
}
